import { DependentDropdownField } from './DependentDropdownField';
import { useTranslations } from '@/hooks';

const SOLD_TO_CLEARS = Object.freeze(['shippingToId']);

/**
 * Props:
 *   options   customer options
 *   disabled  locked while only the quantity may change
 */
export const SoldToField = ({ options, disabled = false }) => {
  const t = useTranslations();

  return (
    <DependentDropdownField
      searchable
      name="soldToId"
      label={t('FIELD_SOLD_TO')}
      placeholder={t('COMMON_SELECT')}
      searchPlaceholder={t('COMMON_SEARCH_CUSTOMER')}
      emptyMessage={t('COMMON_NO_OPTIONS')}
      noResultsMessage={t('COMMON_NO_MATCHES')}
      options={options}
      clears={SOLD_TO_CLEARS}
      disabled={disabled}
    />
  );
};
